import { G_EXPORT_TRANSACTION, DASH_VENDOR_TILES, U_VIEW_USERS,
    U_USER_ADMIN, PAY_OVERVIEW_STOP_PAYMENT } from "../config/PermissionTypes";
import { FF_PAY_SRCH_EXPORT, FF_DASH_VENDOR_TILES, FF_USERS_PAGE,
    FF_ROLES_PAGE, FF_PAY_OVERVIEW_STOP_PAYMENT } from "../config/FeatureFlagTypes";

const DISABLED_VALUE = 'disabled';

export function isFeatureDisabled(requiredFeatureFlags, availableFeatureFlags) {

    if (typeof requiredFeatureFlags !== 'undefined' && requiredFeatureFlags !== null) {
        // check feature flag first
        let found = availableFeatureFlags?.find(featureFlag =>
            requiredFeatureFlags === featureFlag.feature_code);

        return typeof found !== 'undefined' && found.status_code === DISABLED_VALUE;
    }
    return false;
}


//Allows for use to have many flags and many permissions in one Has tag.
//For every new permission/ Feature flag combination we will want to add here.
const featureFlagPermissions = {
    [FF_PAY_SRCH_EXPORT] : [G_EXPORT_TRANSACTION],
    [FF_DASH_VENDOR_TILES] : [DASH_VENDOR_TILES],
    [FF_USERS_PAGE] : [U_VIEW_USERS, U_USER_ADMIN],
    [FF_ROLES_PAGE] : [U_USER_ADMIN],
    [FF_PAY_OVERVIEW_STOP_PAYMENT] : [PAY_OVERVIEW_STOP_PAYMENT]

}
export function lookUpFeatureFlagPermissions(featureFlagName){
    return featureFlagPermissions[featureFlagName];
}